define(
	'Eureka.MaxaPartPicker.MaxaPartPicker'
,   [
		'Eureka.MaxaPartPicker.MaxaPartPicker.View',
		'Eureka.MaxaPartPicker.MaxaPartPickerMain.View',
		'Eureka.MaxaPartPicker.New.MaxaPartPickerMain.View'
	]
,   function (
		MaxaPartPickerView,
		MaxaPartPickerMainView,
		MaxaPartPickerNewMainView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				layout.addChildView('MaxaPartPicker', function() {
					return new MaxaPartPickerView({ container: container });
				});
			}

			var PageType = container.getComponent('PageType')

			PageType.registerPageType({
				name: 'MaxaPartPicker',
				routes: ['partspickertest'],
				view: MaxaPartPickerMainView,
				defaultTemplate: {
					name: 'eureka_maxapartpicker_maxapartpickermain.tpl',
					displayName: 'Part Picker',
				}
			})

			PageType.registerPageType({
				name: 'MaxaPartPicker',
				routes: ['partspicker'],
				view: MaxaPartPickerNewMainView,
				defaultTemplate: {
					name: 'eureka_maxapartpicker_newmaxapartpickermain.tpl',
					displayName: 'Part Picker',
				}
			})
		}
	};
});
